var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Voting progress ")]),_c('v-card-text',[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"table"}}):_c('v-data-table',{attrs:{"headers":_vm.judgingSummaryHeaders,"items":_vm.teamResults}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }